import "./Home.css";

import React from "react";
import SubscribedUserHome from "./components/SubscribedUserHome/SubscribedUserHome";
import TrialUserHome from "./components/TrialUserHome/TrialUserHome";
import { selectUser } from "../../redux/reducers/userReducer";
import { useFetchHomeData } from "../../hooks/APIs/useFetchHomeData";
import { usePagination } from "../../hooks/usePagination";
import { useSelector } from "react-redux";

const Home: React.FC = () => {
  const user = useSelector(selectUser);
  const { homeData, fetchData } = useFetchHomeData();
  usePagination(homeData?.pagination?.hasNextPage, fetchData);

  if (!homeData) {
    return null;
  }

  return (
    <div className="home-page">
      {user?.data?.user?.user_id ? (
        <SubscribedUserHome homeData={homeData} />
      ) : (
        <TrialUserHome homeData={homeData} />
      )}
    </div>
  );
};

export default Home;
